
VLW.controllers.Terroir = class extends VLW.controllers.Home {
	constructor(a, b) {
		super(a, b);
		this.pixi.align="cc";
		this.pixi.displacementType=VLW.HomePIXIDisplacement.DISPLACEMENTTYPE_TERROIR;
		this.constructor.setStyleMenuHover("color_gris");

	}

	loadPIXIResources(){
		let _loader = new PIXI.loaders.Loader();
		_loader.add("image", this.getPIXIResourcesBackground());
		_loader.add("mask"			, "/images/mask/terroir.png");
		_loader.add("displacement"	, "/images/d3.jpg");
		_loader.load((loader, resources)=>{this.pixi.resources = resources;loader.destroy()});
	}
};